module.exports = __webpack_public_path__ + "static/media/a1.00d5ae1.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lijunfeng/a1.mp3
// module id = q9Vp
// module chunks = 0